import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=faf2af0c&scoped=true&"
import script from "./AuthForm.vue?vue&type=script&lang=js&"
export * from "./AuthForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthForm.vue?vue&type=style&index=0&id=faf2af0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2af0c",
  null
  
)

export default component.exports